"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateRBACAppConfig = function (user) {
    var config = {};
    var features = user.features;
    var hasAdminEmailNotificationSettings = utils_1.hasFeature(features, { featureName: "admin_email_notifications", accessLevel: "READ" });
    var hasAccountActivityNotifications = utils_1.hasFeature(features, { featureName: "prospector", accessLevel: "READ" });
    var canWriteToConvos = utils_1.hasFeature(features, { featureName: "convo_view_all", accessLevel: "WRITE" })
        || utils_1.hasFeature(features, { featureName: "convo_view_no_participants", accessLevel: "WRITE" })
        || utils_1.hasFeature(features, { featureName: "convo_view_only_mine", accessLevel: "WRITE" });
    /*** Main Nav ***/
    config = ramda_1.set(ramda_1.lensProp('hasShipyard'), true, config);
    /*** Popover ***/
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), hasAdminEmailNotificationSettings || hasAccountActivityNotifications || canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasAgentStatus'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasDriftStatus'), utils_1.hasFeature(features, { featureName: "widget_settings", accessLevel: "READ" }), config);
    /*** Account Switcher ***/
    config = ramda_1.set(ramda_1.lensProp('hasDevPlatformSwitch'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasInsiderSwitch'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasVideoSwitch'), false, config);
    return config;
};
exports["default"] = generateRBACAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/trafficControl/rbac.js
// module id = b7DX
// module chunks = 88